import { render } from "./FooterComponent.vue?vue&type=template&id=2e8c8ce4"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PC\\Documents\\vue.js\\marvel\\marvel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__